import { useDuplexSectionQuery } from '@ecomm/home-landing-data'
import {
  DuplexSection,
  type GatsbyDuplexSectionSchema
} from '@ecomm/shared-sections'

export function HomeLandingDuplexSection({
  contentful_id
}: GatsbyDuplexSectionSchema) {
  const { leftCollection, rightCollection } =
    useDuplexSectionQuery(contentful_id)
  return (
    <DuplexSection left={leftCollection.items} right={rightCollection.items} />
  )
}
